import React, { useState } from 'react';

export const useHover = <T>(
  onMouseEnter?: React.MouseEventHandler<T>,
  onMouseLeave?: React.MouseEventHandler<T>
): {
  hovered: boolean;
  handleMouseEnter: React.MouseEventHandler<T>;
  handleMouseLeave: React.MouseEventHandler<T>;
} => {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = React.useCallback<React.MouseEventHandler<T>>(
    (e) => {
      setHovered(true);

      if (onMouseEnter) {
        onMouseEnter(e);
      }
    },
    [onMouseEnter]
  );

  const handleMouseLeave = React.useCallback<React.MouseEventHandler<T>>(
    (e) => {
      setHovered(false);

      if (onMouseLeave) {
        onMouseLeave(e);
      }
    },
    [onMouseLeave]
  );

  return { hovered, handleMouseEnter, handleMouseLeave };
};
